var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 0,
    viewBox: "0 0 12 14",
    height: "1em",
    width: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5782 9.92529V3.5953L6.00673 0.430298L0.435303 3.5953V9.92529L6.00673 13.0924L11.5782 9.92529Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98501 6.63386V12.9574H5.99359L0.428589 9.79671V3.47314L5.99359 6.63386",
    fill: "currentColor",
    fillOpacity: 0.33
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00857 6.63386V12.9574H6L11.565 9.79671V3.47314L6 6.63386",
    fill: "currentColor",
    fillOpacity: 0.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.214289 10.2981L5.78571 13.4631C5.85087 13.5007 5.92477 13.5205 6 13.5205C6.07523 13.5205 6.14913 13.5007 6.21429 13.4631L11.7857 10.2981C11.8511 10.2604 11.9054 10.206 11.943 10.1405C11.9806 10.075 12.0003 10.0008 12 9.92527V3.59527C12.0003 3.51975 11.9806 3.4455 11.943 3.38002C11.9054 3.31455 11.8511 3.26017 11.7857 3.22242L6.21429 0.0574176C6.14913 0.0198027 6.07523 0 6 0C5.92477 0 5.85087 0.0198027 5.78571 0.0574176L0.214289 3.22242C0.148887 3.26017 0.0946241 3.31455 0.0569941 3.38002C0.0193641 3.4455 -0.000296436 3.51975 3.37836e-06 3.59527V9.92527C-0.000296436 10.0008 0.0193641 10.075 0.0569941 10.1405C0.0946241 10.206 0.148887 10.2604 0.214289 10.2981ZM0.857146 4.33027L5.57143 7.00456V12.351L0.857146 9.6767V4.33027ZM6.42857 12.3596V7.01527L11.1429 4.33027V9.6767L6.42857 12.3596ZM6 0.920989L10.7143 3.59527L6 6.26741L1.28572 3.59527L6 0.920989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceBoxIcon);
export default __webpack_public_path__ + "static/media/deviceBoxIcon.16c2e902dfea3983c26d4b203dc0f486.svg";
export { ForwardRef as ReactComponent };